/**
 * SDT Shared Constants
 * Central source of truth for all status values, stages, categories, and options.
 * Import this file in every context provider to ensure consistency across apps.
 */

// Student/Customer training stages
export const STAGES = ['New', 'Provisional', 'Simulator', 'Road Lesson', 'Graduated'];

// Lead statuses
export const LEAD_STATUSES = ['New', 'Contacted', 'Interested', 'Enrolled', 'Lost'];

// Customer statuses
export const CUSTOMER_STATUSES = ['Active', 'Watchlist', 'Inactive', 'Graduated'];

// Lesson types
export const LESSON_TYPES = ['Simulator', 'Road Lesson', 'Theory', 'Assessment'];

// Lesson statuses
export const LESSON_STATUSES = ['Scheduled', 'Confirmed', 'In Progress', 'Completed', 'Cancelled', 'No Show'];

// Lead sources
export const SOURCES = ['Facebook', 'Instagram', 'Referral', 'Walk-in', 'Website', 'Other'];

// KPI statuses
export const KPI_STATUSES = ['On Track', 'At Risk', 'Behind', 'Completed'];

// Payment methods
export const PAYMENT_METHODS = ['Cash', 'Bank Transfer', 'Mobile Money'];

// Installment types
export const INSTALLMENT_TYPES = [
    { id: 'weekly', name: 'Weekly' },
    { id: 'monthly', name: 'Monthly' },
    { id: 'full', name: 'Full Payment' }
];

// Expense categories
export const EXPENSE_CATEGORIES = [
    'Marketing',
    'City Council Licence',
    'Vehicle Insurance/licence',
    'Fuel',
    'Salaries & Wages',
    'Security',
    'Transfer Charges',
    'Communication - Telephone, airtime, internet',
    'Allowances - Transport, food',
    'General Office Maintenance',
    'Electricity',
    'Vehicle Repairs & Maintenance',
    'City Parking',
    'Training Ground Fees/ Association',
    'Rent, Utilities',
    'Intercompany - Bulawayo and other branches',
    'Insurance',
    'VID Booking',
    'Booking Refund',
    'Intercompany - Ciprotek',
    'Director withdrawals',
    'Lessons and car hire',
    'PAYE',
    'NSSA',
    'Provisional Tax',
    'Tax payable'
];

// Status distribution chart options
export const STATUS_DISTRIBUTION_OPTIONS = ['Active', 'Watchlist', 'Inactive'];

// Helper functions
export const getInstallmentName = (id) => INSTALLMENT_TYPES.find(t => t.id === id)?.name || id;
